import {
  ArrivalDepartureEmployeeType,
  UnScheduledArrivalDepartureType,
} from '../../../../services/dashboard';

export type ModalType =
  | 'scheduled'
  | 'in'
  | 'out'
  | 'difference'
  | 'late'
  | 'overtime'
  | 'unscheduled-arrivals'
  | 'unscheduled-departures';

export type DataType = ArrivalDepartureEmployeeType &
  UnScheduledArrivalDepartureType;

export const ModalTypeConfig: Record<
  ModalType,
  {
    title: string;
    fields: (
      | keyof DataType
      | 'punchDate'
      | 'actualInPunchDate'
      | 'actualOutPunchDate'
    )[];
  }
> = {
  scheduled: {
    title: 'Scheduled',
    fields: ['employeeName', 'position', 'startTime', 'endTime'],
  },
  in: {
    title: 'In',
    fields: [
      'employeeName',
      'position',
      'actualInPunchDate',
      'actualInPunchDateTime',
    ],
  },
  out: {
    title: 'Out',
    fields: [
      'employeeName',
      'position',
      'actualOutPunchDate',
      'actualOutPunchDateTime',
    ],
  },
  difference: {
    title: 'Difference',
    fields: ['employeeName', 'position', 'startDateTime', 'endDateTime'],
  },
  late: {
    title: 'Late',
    fields: [
      'employeeName',
      'position',
      'startDateTime',
      'actualInPunchDateTime',
      'actualOutPunchDateTime',
      'lateMinutes',
    ],
  },
  overtime: {
    title: 'Overtime',
    fields: [
      'employeeName',
      'position',
      'startDateTime',
      'endDateTime',
      'actualOutPunchDateTime',
      'overTimeMinutes',
    ],
  },
  'unscheduled-arrivals': {
    title: 'Unscheduled Arrivals',
    fields: ['employeeName', 'positionName', 'punchDate', 'punchTime'],
  },
  'unscheduled-departures': {
    title: 'Unscheduled Departures',
    fields: ['employeeName', 'positionName', 'punchDate', 'punchTime'],
  },
};
